module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b3bLw"))).then(() => parcelRequire('8rm4T'));